import { render, staticRenderFns } from "./PaymentMethodCheckbox.vue?vue&type=template&id=03de160e&scoped=true&"
import script from "./PaymentMethodCheckbox.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodCheckbox.vue?vue&type=style&index=0&id=03de160e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03de160e",
  null
  
)

export default component.exports